<svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <g id="arrow-right">
        <path id="Shape" fill-rule="evenodd" clip-rule="evenodd"
            d="M13.2929 5.79289C13.6834 5.40237 14.3166 5.40237 14.7071 5.79289L20.7071 11.7929C21.0976 12.1834 21.0976 12.8166 20.7071 13.2071L14.7071 19.2071C14.3166 19.5976 13.6834 19.5976 13.2929 19.2071C12.9024 18.8166 12.9024 18.1834 13.2929 17.7929L17.5858 13.5H4C3.44772 13.5 3 13.0523 3 12.5C3 11.9477 3.44772 11.5 4 11.5H17.5858L13.2929 7.20711C12.9024 6.81658 12.9024 6.18342 13.2929 5.79289Z"
            fill="currentColor" />
    </g>
</svg>